import React, { Component } from 'react';
import { red } from '@material-ui/core/colors';



export class IsIeWarning extends Component {

    render() {

        if (isIE()) {
            return <h3 style={{ color: 'red' }}>Vi stödjer ej internet explorer. Vänligen använd en annan webbläsare</h3>
        }

        return (
            null
        );
    }
}

function isIE() {
    var ua = navigator.userAgent;
    /* MSIE used to detect old browsers and Trident used to newer ones*/
    var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;

    return is_ie;
}
